import Vue from 'vue'
import './plugins/axios'
import App from './views/App.vue'
import router from './router'
import '@/assets/css/style.css'
import Localization from './localization'
import application from './controllers/ApplicationController'
import api from './lib/ServerApi'
import SortedTablePlugin from "vue-sorted-table";

Vue.use(SortedTablePlugin);

Vue.config.productionTip = false

window.code = new Vue({
	router,
	created: function(){
		this.init();
	},
	data: function(){
		return {
			Localization: null,
			application: null,
			reports: null,
			busy: null,
			networkError: null
		}
	},
	methods: {
		init: function(){
			this.Localization = Localization;
			Vue.prototype.$Localization = this.Localization;

			Vue.filter('datetime', function(value) { return Localization.datetime(value)});
			Vue.filter('date', function(value) { return Localization.date(value)});
			Vue.filter('str', function(value) { return Localization.str(value)});
			
			this.application = application;
			Vue.prototype.$application = this.application;

			this.api = api
			Vue.prototype.$api = this.api;
			
			// wait unit all references are initialized
			application.init();
			application.initPromise.then(function(){
				Localization.setLanguage(localStorage.getItem('language') || application.getUser().language);
			});
		}
	},
	render: function (h) { return h(App) }
}).$mount('#app');
